import React from "react";
import View from './views';
import { connect } from 'react-redux';
import { DeviceType } from '../../enums';

import {
  activateDevice,
  getStoreInfo,
  updateDeviceInfo,
  updateDeviceApiData,
  updateCurrencyInfo,
  updateDeviceApi,
} from '../../store/actions';
import { getPopupConfig } from '../../components/Popup';
import API from '../../requests';
import constants from '../../globalization';
import EventEmitter from '../../util/event-emitter';
import { version } from '../../../package.json';
import withSocketContext from '../../context-api/SocketContext/withSocketContext';
import CustomizationUtil from "../../util/customization-util";

class AppLoading extends React.Component {
  state = {
    popup: undefined,
  }

  defaultDeviceTypeId = 0;

  componentDidMount() {
    const { history, context } = this.props;
    const { location } = history || {};
    const { state } = location || {};
    const { reactivate, deviceTypeId } = state || {};
    const { setDeviceType } = context;
    API.setURL(process.env.REACT_APP_IAPI_BASE_URL);
    this.defaultDeviceTypeId = deviceTypeId;
    const queryParams = this.getQueryStringParams();
    console.log('appLoading queryParams', queryParams);
    if (reactivate) {
      const {
        reduxProps: { deviceInfo },
      } = this.props;
      this.checkForStoreInfo(null, deviceInfo, reactivate);
    } else if (queryParams.uuid) {
      const { uuid, isSimPay } = queryParams;
      this.activateDeviceViaUuid(uuid, isSimPay);
    } else if (window.ReactNativeWebView) {
      const { dispatchUpdateCurrencyInfo } = this.props;
      const callback = (storeInfo, deviceInfo, mode, deviceApi, RNDevEnv, deviceTypeId) => {
        console.log('reactNativeWebView activation callback', {
            storeInfo,
            deviceInfo,
            mode,
            deviceApi,
            RNDevEnv,
            deviceTypeId
        });
        this.defaultDeviceTypeId = deviceTypeId;
        setDeviceType(deviceTypeId);
        dispatchUpdateCurrencyInfo({ rnDevEnv: RNDevEnv });
        this.checkForStoreInfo(storeInfo, deviceInfo, mode, deviceApi);
      }
      EventEmitter.activateDevice(callback);
    } else {
      this.checkIfDeviceActivated();
    }
  }

  getQueryStringParams = () => {
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    const queryObject = {};
  
    for (const [key, value] of params.entries()) {
      queryObject[key] = value;
    }
  
    return queryObject;
  }

  checkForStoreInfo = (storeInfo, deviceInfo, mode, deviceApi) => {
    if (deviceInfo || mode) {
      const {
        dispatchUpdateDeviceInfo,
        dispatchGetStoreInfo,
        dispatchUpdateDeviceApiData,
        dispatchUpdateDeviceApi,
      } = this.props;
      const { deviceExternalId, apiKey, password } = deviceInfo;
      API.setApiHeaders(apiKey, deviceExternalId, password);
      dispatchUpdateDeviceInfo({ deviceExternalId, apiKey, password });
      dispatchGetStoreInfo(deviceApi?.data?.deviceId);
      dispatchUpdateDeviceApiData(deviceApi.data);
      dispatchUpdateDeviceApi(deviceApi.data);
      if (storeInfo && storeInfo.data) {
        this.onStoreInfoSuccess(storeInfo.data);
      }
    } else {
      this.checkIfDeviceActivated();
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ reduxProps: { deviceApi, storeInfo } }) {
    this.handleDeviceActions(deviceApi);
    this.handleStoreActions(storeInfo, deviceApi);
  }

  handleDeviceActions = deviceApi => {
    const {
      reduxProps: prevReduxProps,
      dispatchGetStoreInfo,
      dispatchUpdateDeviceInfo,
      history,
    } = this.props;
    if (deviceApi.timestamp !== prevReduxProps.deviceApi.timestamp) {
      if (deviceApi.isFetching) {
        const popup = getPopupConfig('spinner');
        popup.heading = constants.activationLoadingHeading;
        this.setState({ popup });
      } else if (deviceApi.data) {
        this.closePopup();
        const { deviceExternalId, apiKey, password, deviceId } = deviceApi.data;
        localStorage.setItem('deviceExternalId', deviceExternalId);
        API.setApiHeaders(apiKey, deviceExternalId, password);
        dispatchUpdateDeviceInfo({ deviceExternalId, apiKey, password });
        dispatchGetStoreInfo(deviceId);
      } else if (deviceApi.error) {
        console.info('deviceApi error', deviceApi.error);
        history.push('/activate');
        return;
      }
    }
  };

  handleStoreActions = (storeInfo, deviceApi) => {
    const { reduxProps: prevReduxProps, dispatchGetStoreInfo } = this.props;
    if (storeInfo.timestamp !== prevReduxProps.storeInfo.timestamp) {
      if (storeInfo.isFetching) {
        const popup = getPopupConfig('spinner');
        popup.heading = constants.activationLoadingHeading;
        this.setState({ popup });
      } else if (storeInfo.data) {
        this.onStoreInfoSuccess(storeInfo.data);
      } else if (storeInfo.error) {
        const popup = getPopupConfig('error', () => {
          dispatchGetStoreInfo(deviceApi?.data?.deviceId);
          this.closePopup();
        });
        popup.message = storeInfo.error.errorMessage;
        this.setState({ popup });
      }
    }
  };

  errorTryAgain = (error, callback) => {
    const popup = getPopupConfig('error');
    popup.message = error;
    popup.buttons = [
      {
        text: constants.retry,
        onClick: () => {
          this.closePopup();
          callback && callback();
        },
      }
    ];
    this.setState({ popup });
  };

  activateDeviceViaUuid = (uuid, isSimPay) => {
    const { dispatchActivateDevice, history } = this.props;
    if (uuid) {
      dispatchActivateDevice({
        uuid,
        isSimPay : isSimPay && isSimPay == 'true',
        appVersion: version
      });
    } else {
      history.push('/activate');
    }
  };

  checkIfDeviceActivated = () => {
    const { dispatchActivateDevice, history, match } = this.props;
    let isSimPay = false;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      isSimPay = true;
    }

    const { externalId } = match?.params || {}; // externalId will be available if sweb is launched from the Portal
    const deviceExternalId = localStorage.getItem('deviceExternalId');
    const dExternalId = externalId || deviceExternalId;
    /** First check for externalId which comes from launched url
     * If externalId is not empty - call activate device using externalId
     * If externalId is blank then look for deviceExternalId in localStorage
     * 
     * If cached deviceExternalId is not blank - call activate device
     * Else navigate to activate screen
    */
    if (dExternalId) {
      dispatchActivateDevice({
        deviceExternalId: dExternalId,
        isSimPay,
        appVersion: version,
      });
    } else {
      history.push('/activate');
    }
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  onStoreInfoSuccess = (response) => {
    const {
      dispatchUpdateDeviceInfo,
      reduxProps: { deviceInfo, deviceApi },
      history,
      dispatchUpdateCurrencyInfo,
    } = this.props;
    const { deviceGroup } = deviceApi?.data || {};
    const { startMode } = deviceGroup || {};

    dispatchUpdateDeviceInfo({ ...deviceInfo, ...response });
    let countryInfo = {};
    if (response.country === 4) {
      countryInfo = {
        currency: '£',
        iso2: 'GB',
      }
    } else {
      countryInfo = {
        currency: '$',
        iso2: 'US',
      }
    }
    dispatchUpdateCurrencyInfo(countryInfo);
    if (this.defaultDeviceTypeId && this.defaultDeviceTypeId !== 0) {
      if (this.defaultDeviceTypeId === DeviceType.FIREBOARD_WEBVIEW) {
        if (startMode === 8) {
          history.push("/dashboard");
        } else {
          history.push("/fireboard");
        }
      } else if (this.defaultDeviceTypeId === DeviceType.TABLE_RESERVATION) {
        CustomizationUtil.getCustomizeWaitlist(response?.brandId, 12, () => history.push("/tms"));
      } else if (this.defaultDeviceTypeId === DeviceType.PRINT_SERVER) {
        history.push("/printRequests");
      } else if (this.defaultDeviceTypeId === DeviceType.KITCHEN_APP) {
        history.push("/kitchen");
      } else if (this.defaultDeviceTypeId === DeviceType.PAYMENT_AUDIO_JACK) {
        history.push("/serverApp");
      }
    } else {
      if (response.deviceTypeId === DeviceType.FIREBOARD_WEBVIEW) {
        if (startMode === 8) {
          history.push("/dashboard");
        } else {
          history.push("/fireboard");
        }
      } else if (response.deviceTypeId === DeviceType.TABLE_RESERVATION) {
        CustomizationUtil.getCustomizeWaitlist(response?.brandId, 12, () => history.push("/tms"));
      } else if (response.deviceTypeId === DeviceType.PRINT_SERVER) {
        history.push("/printRequests");
      } else if (response.deviceTypeId === DeviceType.KITCHEN_APP) {
        history.push("/kitchen");
      } else if (response.deviceTypeId === DeviceType.PAYMENT_AUDIO_JACK) {
        history.push("/serverApp");
      }
    }
  };

  getProps = () => {
    const { popup } = this.state;
    return {
      popup,
      closePopup: this.closePopup,
    };
  }

  render() {
    const viewProps = this.getProps();
    return <View {...viewProps} />;
  }
}

const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = dispatch => ({
  dispatchActivateDevice: payload => {
    dispatch(activateDevice(payload));
  },
  dispatchGetStoreInfo: deviceId => {
    dispatch(getStoreInfo(deviceId));
  },
  dispatchUpdateDeviceInfo: licenseKey => {
    dispatch(updateDeviceInfo(licenseKey));
  },
  dispatchUpdateDeviceApiData: payload => {
    dispatch(updateDeviceApiData(payload));
  },
  dispatchUpdateCurrencyInfo: payload => {
    dispatch(updateCurrencyInfo(payload));
  },
  dispatchUpdateDeviceApi: payload => {
    dispatch(updateDeviceApi(payload));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSocketContext(AppLoading));
